import React from "react";
import { Form, Input, Icon, Tooltip } from "@xala/common-ui";
import { useTranslation } from "react-i18next";
import { INotificationField } from "./INotificationField";

export const ImageUrlField = ({
  notification,
  isEditMode,
  isHidden,
}: INotificationField) => {
  const { t } = useTranslation();

  if (isHidden || notification?.Provider === "EMAIL") {
    return null;
  }

  return (
    <Form.Item
      name="ImageUrl"
      label={
        <span>
          {t("NOTIFICATION_IMAGE_URL_FIELD")}&nbsp;
          <Tooltip title="En aquest camp es carrega de forma automàtica el URL de la imatge a enviar. La imatge es pot introduir manualment, però en aquest cas haurà de complir els requisits establerts, i no ens fem responsables del seu funcionament, ja que no es desarà a la caché de l'aplicació">
            <Icon type="question-circle" />
          </Tooltip>
        </span>
      }
      key="ImageUrl"
      initialValue={isEditMode ? notification?.ImageUrl || "" : ""}
    >
      <Input placeholder={t("NOTIFICATION_IMAGE_URL_INPUT_FIELD")} />
    </Form.Item>
  );
};
